import Loadable from '../../components/loadable';

const ContactForms = Loadable({
  loader: () => import('react/pages/contact_forms/contact_forms/contact_forms'),
});

angular.module('gym').value('ContactForms', ContactForms);
